<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-row>
        <b-col>
          <b-button
          class="hide-print mt-3 ml-2 float-right"
          @click.prevent="goback"
          variant="secondary"
          size="sm"
        >BACK</b-button>
        </b-col>
      </b-row>
    <b-row>
      <b-col>
        <p class="reg-heading-tab mb-3">EMI Schedule</p>
        <b-table
          ref="emiTable"
          show-empty
          head-variant="dark"
          empty-text="No EMI schedule available. Please ensure disbursement is completed first."
          stacked="md"
          bordered
          striped
          :items="emiList"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          @row-selected="onRowSelected"
          style="font-size:12px"
        >
          <template v-slot:cell(SL)="row">
            <span aria-hidden="true">{{row.index+1+(10*(currentPage-1))}}</span>
          </template>
          <template v-slot:cell(selected)="row">
            <b-form-checkbox
              v-if="row.item.IsDue"
              @change="selectClaim($event,row.index, row.item)"
            >EMI Paid</b-form-checkbox>

            <!-- <template v-if="row.rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not Selected</span>
            </template>-->
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="5">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row class="justify-content-md-center">
            <b-col class="mt-2">
              <p class="reg-heading-tab mb-3">Add New Disbursal</p>
              <div class="reg-tab-container mb-3">
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Bank Name:</b>
                  </b-col>
                  <b-col style="font-size:14px">{{LoanDetails.BankName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Branch Name:</b>
                  </b-col>
                  <b-col style="font-size:14px">{{LoanDetails.BranchName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Approved Amount:</b>
                  </b-col>
                  <b-col>&#8377;{{LoanDetails.SanctionAmount}}</b-col>
                  <b-col md="3">
                    <b style="font-size:14px">Disbursed Amount:</b>
                  </b-col>
                  <b-col md="3">&#8377;{{formatCurrency(TotalDisbursementAmount)}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3" style="font-size:14px">
                    <b>Interest Rate %:</b>
                  </b-col>
                  <b-col md="3" style="font-size:14px">{{LoanDetails.ROI}}</b-col>

                  <b-col md="3" style="font-size:14px">
                    <b>Tenure (months):</b>
                  </b-col>
                  <b-col md="3" style="font-size:14px">{{LoanDetails.LoanTenure}}</b-col>
                </b-row>
              </div>
              <div class="reg-tab-container">
                <b-form-group id="igrp0" label="EMI Paid Date*" label-cols="4" label-size="sm">
                  <b-form-input
                    type="date"
                    placeholder="EMI Paid Date"
                    size="sm"
                    required
                    lazy-formatter
                    v-model="form.EMIPaidDate"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp0" label="EMI Paid Amt*" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="EMI Amount Paid"
                    min="1"
                    step="0.01"
                    size="sm"
                    lazy-formatter
                    required
                    v-model="form.EMIPaidAmt"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="igrp1" label="Principal Amount" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="Start Date"
                    size="sm"
                    disabled
                    v-model="form.PrincipalAmt"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp2" label="Interest Amount" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="End Date"
                    size="sm"
                    required
                    v-model="form.InterestAmt"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="igrp3"
                  horizontal
                  label="Other Charges (Rs)*"
                  label-cols="4"
                  label-size="sm"
                  label-for="inpAmount"
                >
                  <b-form-input
                    id="inpAmount"
                    type="number"
                    v-model="form.PenaltyCharges"
                    required
                    size="sm"
                    placeholder="Other Charges Paid"
                  ></b-form-input>
                </b-form-group>
                <div class="row">
                  <div class="col-md-4">
                    <span class="ln-eng" style="font-size: 0.875rem;">EMI Payment Proof *</span>
                    <p
                      style="font-size: 0.75rem;color:#2284ab;"
                    >Upload Bank Statement Showing EMI Payment or Loan Account Statement</p>
                  </div>
                  <div class="col-md-4">
                    <div v-if="isLoadingImg">
                      <Spinner size="16" message="Uploading..."></Spinner>
                    </div>
                    <b-form-file
                      ref="fiPhotoPath"
                      @change="onFileChange"
                      v-if="(form.UploadEMIPaidProof =='' || !form.UploadEMIPaidProof) && !isLoadingImg"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div
                    class="col-md-4"
                    v-if="form.UploadEMIPaidProof !='' && form.UploadEMIPaidProof"
                  >
                    <a :href="getImgUrl2(form.UploadEMIPaidProof)" target="_blank">
                      <img
                        style="height:30px"
                        :src="getImgUrl(form.UploadEMIPaidProof)"
                        class="img-fluid"
                      />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('EMIPaymentProof', form.UploadEMIPaidProof)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <span class="ln-eng" style="font-size: 0.875rem;">Latest Business Photo *</span>
                    <p
                      style="font-size: 0.75rem;color:#2284ab;"
                    >Upload Latest Photo of Business for which Loan Sanctioned</p>
                  </div>
                  <div class="col-md-4">
                    <div v-if="isLoadingImgB">
                      <Spinner size="16" message="Uploading..."></Spinner>
                    </div>
                    <b-form-file
                      ref="fiBusinessPath"
                      @change="onFileChangeB"
                      v-if="(form.UploadBusinessPhoto =='' || !form.UploadBusinessPhoto) && !isLoadingImgB"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div
                    class="col-md-4"
                    v-if="form.UploadBusinessPhoto !='' && form.UploadBusinessPhoto"
                  >
                    <a :href="getImgUrl2(form.UploadBusinessPhoto)" target="_blank">
                      <img
                        style="height:30px"
                        :src="getImgUrl(form.UploadBusinessPhoto)"
                        class="img-fluid"
                      />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('BusinessPhoto', form.UploadBusinessPhoto)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2 justify-content-md-center" v-if="!getUserData.LockProfile">
            <b-col md="4" sm="12" style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
            <b-col sm="12" style="text-align:right">
              <b-button
                v-if="!saved"
                type="submit"
                style="float:right"
                class="ml-3"
                variant="primary"
              >Submit</b-button>
              <b-button v-if="!saved" type="reset" style="float:right" variant="danger">Reset</b-button>
              <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>

    <!-- Delete Confirmation Modal -->
    <b-modal 
      id="modalConfirm" 
      title="Confirm Delete" 
      @ok="modalConfirm" 
      @cancel="modalCancel"
      ok-variant="danger"
      ok-title="Delete"
      cancel-title="Cancel"
    >
      <p>{{modalInfo}}</p>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import common from "@/apis/common";
import store from '../../store';

export default {
  components: { Spinner },
  props: ["UserID", "ApplicationID"],
  data() {
    return {
      emiList: [],
      fields: [
        { key: "SL", label: "Sr No" },
        { key: "EMIDate", label: "Month", formatter: "convertDateFormat" },
        { key: "EMIAmount", label: "EMI" },
        { key: "OpeningBalance", label: "Opening Amount" },
        { key: "PrincipalAmount", label: "Principal" },
        { key: "InterestAmount", label: "Interest" },
        { key: "ClosingBalance", label: "Balance" },
        { key: "selected", label: "Claim" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50,100,200,300,400,500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      isLoadingImg: false,
      isLoadingImgB: false,
      minAmount: 10000,
      maxAmount: 1000000,
      Photo: "",
      BusinessPhoto:"",
      form: {
        ClaimEMIID: "00000000-0000-0000-0000-000000000000",
        EMISheduledID: "00000000-0000-0000-0000-000000000000",
        UserID: "",
        EMIPaidDate: null,
        EMIPaidAmt: 0,
        PrincipalAmt: 0,
        InterestAmt: 0,
        PenaltyCharges: 0,
        UploadBankStmt: "",
        UploadEMIPaidProof: "",
        ClaimStatus: 1,
        ClaimPaidStatus: 1,
        UpdatedBy: "",
        EmiScheduleIds: [],
        UploadBusinessPhoto:""
      },
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0
      },
      LockProfile: false,
      saved: false,
      LockProfile: false,
      dt: null,
      TotalDisbursementAmount: 0,
      selected: [],
      selecteObj: {
        Document: "",
        Path: ""
      },
      modalInfo: ""
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) {
        return '0';
      }
      return Number(amount).toLocaleString('en-IN');
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    goback() {
      //this.$router.back();
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: this.$store.getters.getUserDistrict,
          userApprovalStatus: this.$store.getters.getAppStatus,
          userLoanType: 1
        }
      });
    },
    selectClaim(checked, index, item) {
      //console.log('item',item);
      if (checked) {
        this.form.InterestAmt += item.InterestAmount;
        this.form.PrincipalAmt += item.PrincipalAmount;
        this.form.EMIPaidAmt += item.EMIAmount;
        this.form.EmiScheduleIds.push(item);
      } else {
        this.form.InterestAmt -= item.InterestAmount;
        this.form.PrincipalAmt -= item.PrincipalAmount;
        this.form.EMIPaidAmt -= item.EMIAmount;
        _.remove(this.form.EmiScheduleIds, function(n) {
          return n.EMIScheduleID == item.EMIScheduleID;
        });
      }
      //console.log('target',this.form.EmiScheduleIds);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(items) {
      this.selected = items;
      let int = 0;
      let prnc = 0;
      let emi = 0;
      this.form.EmiScheduleIds = [];

      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array
        int += this.selected[i].InterestAmount; //Do the math!
        prnc += this.selected[i].PrincipalAmount;
        emi += this.selected[i].EMIAmount;
        this.form.EmiScheduleIds.push(this.selected[i]);
      }
      this.form.EMISheduledID = this.selected[0].EMIScheduleID;
      this.form.InterestAmt = int;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.InterestAmount;
      // }, 0);

      this.form.PrincipalAmt = prnc;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.PrincipalAmount;
      // }, 0);

      this.form.EMIPaidAmt = emi;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.EMIAmount;
      // }, 0);
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        LoanDisbursementID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "",
        UpdatedBy: "",
        DisbursalDate: null,
        EmiStartDate: null,
        EmiEndDate: null,
        VerifiedStatus: 1,
        TrancheNo: "",
        UpdatedDate: null,
        SeparateTenure: false,
        DisburmentAmount: 0,
        EmiAmount: 0,
        HOApprovedAmount: 0,
        UploadEMIPaidProof: "",
        UploadBankStatement: "",
        UploadBusinessPhoto:"",
      };
      this.Photo="";
      this.BusinessPhoto="";
    },
    onClickButton(evt) {
      evt.preventDefault();
      this.$router.push("/claims");
    },
    async onSubmit(evt) {
      evt.preventDefault();
      if (
        Number(this.form.EMIPaidAmt) <
        Number(this.form.PrincipalAmt) +
          Number(this.form.InterestAmt) +
          Number(this.form.PenaltyCharges)
      ) {
        this.alertText =
          "EMI Amount can't be less than Addition of Principal, Interest and Charges.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      if (
        this.form.EmiScheduleIds.length == 0 ||
        Number(this.form.PrincipalAmt) + Number(this.form.InterestAmt) <= 0
      ) {
        this.alertText = "Please select EMIs to be paid from table.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      // Check if required files have been uploaded
      if (!this.form.UploadEMIPaidProof) {
        this.alertText = "Please upload EMI Payment Proof before submitting.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      if (!this.form.UploadBusinessPhoto) {
        this.alertText = "Please upload Business Photo before submitting.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      this.showDismissibleAlert = false;
      this.isLoading = true;

      var userinfo = this.$store.getters.loggedUser;
      this.form.UpdatedBy = userinfo.UserId;
      this.form.UserID = userinfo.UserId;
      this.form.LoanSanctionID = this.LoanDetails.LoanSanctionID;

      let promise = apis.saveClaim(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            //to add - Claim Total Value and Row Locking.
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getUserData() {},
    async onFileChange(e) {
      this.isLoadingImg = true;
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.isLoadingImg = false;
        return;
      }

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input. Only JPG, PNG, JPEG, and PDF files are allowed.";
        this.variant = "warning";
        this.$refs.fiPhotoPath.reset();
        this.isLoadingImg = false;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var filepath = userid + "!!~~!!" + "EMIPaymentProof_." + extn;
      
      let data = new FormData();
      let file = e.target.files[0];
       
      data.append('file', file, filepath);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + store.getters.authToken,
        }
      }
       
      axios.post('https://api.mahila.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UploadEMIPaidProof = res.data;
            this.alertText = "EMI Payment Proof uploaded successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading file";
            this.showDismissibleAlert = true;
            this.$refs.fiPhotoPath.reset();
          }
          this.isLoadingImg = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error uploading file";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiPhotoPath.reset();
          this.isLoadingImg = false;
        });
    },
    async onFileChangeB(e) {
      this.isLoadingImgB = true;
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.isLoadingImgB = false;
        return;
      }

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input. Only JPG, PNG, JPEG, and PDF files are allowed.";
        this.variant = "warning";
        this.$refs.fiBusinessPhoto.reset();
        this.isLoadingImgB = false;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var filepath = userid + "!!~~!!" + "BusinessPhoto_." + extn;
      
      let data = new FormData();
      let file = e.target.files[0];
       
      data.append('file', file, filepath);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + store.getters.authToken,
        }
      }
       
      axios.post('https://api.mahila.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.form.UploadBusinessPhoto = res.data;
            this.alertText = "Business photo uploaded successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading file";
            this.showDismissibleAlert = true;
            this.$refs.fiBusinessPhoto.reset();
          }
          this.isLoadingImgB = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error uploading file";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs.fiBusinessPhoto.reset();
          this.isLoadingImgB = false;
        });
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      // Handle delete based on the document type
      if (this.selecteObj.Document === 'EMIPaymentProof') {
        this.form.UploadEMIPaidProof = "";
        if (this.$refs.fiPhotoPath) {
          this.$refs.fiPhotoPath.reset();
        }
        this.alertText = "EMI Payment Proof removed successfully.";
      } else if (this.selecteObj.Document === 'BusinessPhoto') {
        this.form.UploadBusinessPhoto = "";
        if (this.$refs.fiBusinessPath) {
          this.$refs.fiBusinessPath.reset();
        }
        this.alertText = "Business Photo removed successfully.";
      }
      
      this.variant = "success";
      this.showDismissibleAlert = true;
      
      // Reset selection object
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    deleteDocument2(document, path) {
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let documentName = document === 'EMIPaymentProof' ? 'EMI Payment Proof' : 'Business Photo';
      let info = "Are you sure you want to delete the " + documentName + "?";
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },

    getSanctionLetterDetails() {
      // Use the applicant's UserID from route params or props, not the logged-in user's ID
      let userid = this.$route.params.UserID || this.UserID || this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadSanctionLetterByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.LoanDetails = response.body;
            this.$store.dispatch("setSanctionLetter", this.LoanDetails);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    getEMIList() {
      let applicationid = this.$store.getters.getApplicationID;

      let promise = apis.getSehedule(applicationid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200 && response.body && response.body.length > 0) {
            this.emiList = response.body;
          } else {
            // If no EMI schedule found by application ID, try to get by disbursement
            this.getEMIListByDisbursement();
          }
          this.isLoading = false;
        })
        .catch(err => {
          // If error with application ID, try disbursement approach
          this.getEMIListByDisbursement();
        });
    },

    getEMIListByDisbursement() {
      // Use the applicant's UserID from route params or props, not the logged-in user's ID
      let userid = this.$route.params.UserID || this.UserID || this.$store.getters.loggedUser.UserId;

      // First get disbursement details to get disbursement IDs
      let promise = apis.ReadLoanDisbursementByUserID(userid);

      promise
        .then(response => {
          if (response.status == 200 && response.body && response.body.length > 0) {
            let disbursements = response.body;
            // Get EMI schedule for the latest/first disbursement
            // You may need to modify this logic based on your business requirements
            let disbursementId = disbursements[0].LoanDisbursementID;
            
            let emiPromise = apis.getSeheduleByDisbursement(disbursementId);
            emiPromise
              .then(emiResponse => {
                if (emiResponse.status == 200) {
                  this.emiList = emiResponse.body || [];
                } else {
                  this.alertText = "No EMI schedule found. Please ensure disbursement details are properly saved.";
                  this.variant = "warning";
                  this.showDismissibleAlert = true;
                }
              })
              .catch(emiErr => {
                this.alertText = "Error loading EMI schedule: " + emiErr.message;
                this.showDismissibleAlert = true;
                this.variant = "danger";
              });
          } else {
            this.alertText = "No disbursement details found. Please complete disbursement process first.";
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    getDisbursementDetails() {
      // Use the applicant's UserID from route params or props, not the logged-in user's ID
      let userid = this.$route.params.UserID || this.UserID || this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadLoanDisbursementByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            // Calculate total disbursement amount
            let disbursements = response.body;
            this.TotalDisbursementAmount = 0;
            if (disbursements && disbursements.length > 0) {
              for (let i = 0; i < disbursements.length; i++) {
                this.TotalDisbursementAmount += disbursements[i].DisburmentAmount || 0;
              }
            }
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getSanctionLetterDetails();
    this.getEMIList();
    this.getDisbursementDetails();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimUpload/UploadClaim.vue